import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { useMonitoringModel } from "../monitoringModel";
import { IMonitoringDetail } from "../monitoringService";
import { formatNum } from "@/utils/utils";
import "./style.css"
import { useDictModel } from "@/views/base/dict/dictModel";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys,
    } = useMonitoringModel();
    const { getTreeNodeName } = useDictModel(() => []);
    useEffect(() => {
        loadData();
    }, [])

    const columns: ColumnsType<IMonitoringDetail> = [
        {
            title: '序号',
            fixed: "left", width: 60, align: "center", render: (t, r, i) => i + 1
        },
        { title: "单据编号", width: 200, dataIndex: "code" },
        {
            title: "主单",
            className: "main",
            children: [
                { title: "单据状态", width: 160, dataIndex: "status", render: text => getTreeNodeName(text) },
                { title: "单据类型", width: 160, dataIndex: "tradeTypeName" },
                { title: "工时数量", width: 160, dataIndex: "itemNum" },
                { title: "配件数量", width: 160, dataIndex: "num" },
                { title: "工时费", width: 120, dataIndex: "itemAmount" },
                { title: "配件费", width: 120, dataIndex: "amount" },
                { title: "优惠后工时", width: 120, dataIndex: "receivedItemAmount" },
                { title: "优惠后配件", width: 160, dataIndex: "receivedMaterialAmount", render: (text) => text ? '￥' + text : '￥0' },
                { title: "费用合计", width: 120, dataIndex: "totalAmount", render: (text) => text ? '￥' + text : '￥0' },
                { title: "优惠金额", width: 120, dataIndex: "discountTotalAmount", render: (text) => text ? '￥' + text : '￥0' },
                { title: "营业额", width: 120, dataIndex: "receivedAmount", render: (text) => text ? '￥' + text : '￥0' },
                { title: "销售成本", width: 120, dataIndex: "costAmount", render: (text) => text ? '￥' + text : '￥0' },
                { title: "营业额差异", width: 120, dataIndex: "receivedAmountDiff", render: (text) => text ? '￥' + text : '￥0' },
                { title: "毛利差异", width: 120, dataIndex: "masterProfitDiff", render: (text) => text ? '￥' + text : '￥0' },
                { title: "费用合计差异", width: 120, dataIndex: "totalAmountDiff", render: (text) => text ? '￥' + text : '￥0' },
            ]
        }, {
            title: "明细",
            children: [
                { title: "工时数量", width: 160, dataIndex: "ditemNum" },
                { title: "配件数量", width: 120, dataIndex: "dnum" },
                { title: "工时费", width: 120, dataIndex: "ditemAmount" },
                { title: "配件费", width: 160, dataIndex: "damount", render: (text) => text ? '￥' + text : '￥0' },
                { title: "工时小计", width: 120, dataIndex: "dreceivedItemAmount", render: (text) => text ? '￥' + text : '￥0' },
                { title: "配件小计", width: 120, dataIndex: "dreceivedMaterialAmount", render: (text) => text ? '￥' + text : '￥0' },
                { title: "销售成本", width: 120, dataIndex: "dcostAmount", render: (text) => text ? '￥' + text : '￥0' },
                { title: "销售毛利", width: 120, dataIndex: "dprofit", render: (text) => text ? '￥' + text : '￥0' },
            ]
        }, {
            title: "主单对应明细",
            children: [
                { title: "工时数差异", width: 160, dataIndex: "itemNumDiff" },
                { title: "配件数差异", width: 120, dataIndex: "numDiff" },
                { title: "工时费差异", width: 120, dataIndex: "itemAmountDiff" },
                { title: "配件费差异", width: 120, dataIndex: "amountDiff", render: (text) => text ? '￥' + text : '￥0' },
                { title: "优惠后工时差异", width: 120, dataIndex: "receivedItemAmountDiff", render: (text) => text ? '￥' + text : '￥0' },
                { title: "优惠后配件差异", width: 120, dataIndex: "receivedMaterialAmountDiff", render: (text) => text ? '￥' + text : '￥0' },
                { title: "费用合计差异", width: 120, dataIndex: "dtotalAmountDiff", render: (text) => text ? '￥' + text : '￥0' },
                { title: "营业额差异", width: 120, dataIndex: "dreceivedAmountDiff", render: (text) => text ? '￥' + text : '￥0' },
                { title: "销售成本差异", width: 120, dataIndex: "costAmountDiff", render: (text) => text ? '￥' + text : '￥0' },
            ]
        }

    ];

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            loading={loading}
            // rowSelection={{
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     //全部选中时  (存string[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         let changeRowId = changeRows.map(item => item.id);
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
            //             : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
            //     },
            //     onSelect: (record) => onRow(record.id),
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.id),
            //     onContextMenu: (e) => {
            //         e.preventDefault();
            //         setSelectedRowKeys([record.id]);
            //     }
            // })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
